import { Trans } from '@lingui/macro';
import { Box } from '@material-ui/core';
import FormSection from '../../../form/FormSection';
import DeviceCommonFields from './DeviceCommonFields';
import DeviceDetailProperties from './DeviceDetailProperties';
import { useDeviceInfraContext } from './DeviceInfraContext';

/**
 * Orchestrates the Device Details and Properties sections.
 * Device Details: always shown (form fields).
 * Properties: shown for existing devices, varies by type (server vs non-server).
 */
const DeviceDetailSection = () => {
    const { isCreateAction } = useDeviceInfraContext();

    return (
        <>
            <FormSection title={<Trans>Device Details</Trans>}>
                <DeviceCommonFields />
            </FormSection>
            {!isCreateAction && (
                <FormSection title={<Trans>Properties</Trans>}>
                    <Box mt={1.5} mb={0.5}>
                        <DeviceDetailProperties />
                    </Box>
                </FormSection>
            )}
        </>
    );
};

export default DeviceDetailSection;
